var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Say Lib
import ImageUpload from "../../ImageUpload";
import ErrorMessage from "../../../Atoms/ErrorMessage";
import withControl from "../../../../hoc/withFormControl";
/**
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
var HookImageUpload = function (_a) {
    var name = _a.name, callback = _a.callback, _b = _a.controllerFields, _c = _b.field, onChange = _c.onChange, value = _c.value, errors = _b.formState.errors, _d = _a.disabled, disabled = _d === void 0 ? false : _d, rest = __rest(_a, ["name", "callback", "controllerFields", "disabled"]);
    /**
     * trigger side-effect if needed
     */
    var handleChange = function (imgData) {
        var imgFile = imgData.imgFile, imgUrl = imgData.imgUrl;
        if (callback) {
            callback(imgFile);
        }
        onChange(imgUrl);
    };
    return (_jsxs("div", { children: [_jsx("div", { children: _jsx(ImageUpload, __assign({ value: value, onChange: handleChange, disabled: disabled }, rest)) }), _jsx(ErrorMessage, { errors: errors, name: name })] }));
};
export { HookImageUpload }; // for react-docgen-typescript
export default withControl(HookImageUpload);
